import { useEffect, useState } from "react";
import TitleHeader from "./CardComponents/TitleHeader";
import ImageCarousel from "./CardComponents/ImageCarousel";
import FavoriteButton from "./CardComponents/FavoriteButton";
import PriceAndLabel from "./CardComponents/PriceAndLabel";
import CountdownTimer from "./CardComponents/CountdownTimer";
import { getPriceLabel } from "./CardComponents/priceUtils";
import { trackButtonClick } from "@/utils/analytics";
import './CardComponents/SRPCard.css';
import { navigateToProperty } from "@/utils/propertyNavigation";

const formatAuctionDate = (dateStr) => {
  if (!dateStr) return "";
  try {
    const date = new Date(dateStr);
    if (isNaN(date.getTime())) return "";
    return date.toLocaleDateString("en-US", {
      month: "short",
      day: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  } catch {
    return "";
  }
};

function CardItemMap({item, setShowModal, isNearbyProperty = false}) {
  const [price, setPrice] = useState('');
  const [priceLabel, setPriceLabel] = useState('');

  const onNavigatePDP = () => {
    trackButtonClick({
      eventName: "property_pdp_navigate",
      eventSource: isNearbyProperty ? "PDP Property Interaction" : "Map Property Interaction",
      eventCategory: isNearbyProperty ? "NEW-PDP" : "NEW-SRP",
      eventLabel: `Property ID: ${item.propertyId} | Listing ID: ${item.listingId}`,
      eventParams: { source: isNearbyProperty ? "recommended_properties" : "map" },
    });
    navigateToProperty(item?.listingUrl || `/property/${item?.listingId || item?.propertyId}`, item?.category, item?.propertyStatus);
  };

  const hasValidCountdown =
    item?.listingType === "AUCN" &&
    (item?.propertyStatus === "ACTV" || item?.propertyStatus === "ACTIVE") &&
    typeof item?.auctionTimeLeft === "number"
      ? true
      : false;

  useEffect(() => {
    const price_label = getPriceLabel(item);
    setPriceLabel(price_label?.bidTit);
    setPrice(price_label?.BidAmt);
  }, []);

  return (
    <div className={`listing_list_style ${isNearbyProperty ? 'nearby-tooltip-container': 'map-tooltip-container'}`}>
      <div className={`list-inline-item cursor-pointer ${isNearbyProperty ? 'nearby-info-img' : 'info-img'}`}>
        <ImageCarousel
          onClick={onNavigatePDP}
          item={item}
          isMapCard={true}
        />
      </div>
      <div className={`list-inline-item ${isNearbyProperty ? 'w-100' : ''} flex-wrap`}>
        <div className="tc_content listing_list_style d-flex justify-content-between text-align-left mt10">
          <div className={`list-inline-item d-flex pl5 ${isNearbyProperty ? '' : 'info-header-width'}`}>
            <TitleHeader item={item} onNavigatePDP={onNavigatePDP} isMapCard={true} />
          </div>
            {!isNearbyProperty && (
              <div className="list-inline-item cursor-pointer pr10">
                <FavoriteButton
                  item={item}
                  setShowModal={setShowModal}
                  isMapCard={true}
                />
              </div>
            )}
        </div>
        <div className="fp_footer d-flex align-items-center text-align-left justify-content-between mr10 mt5 flex-wrap">
          <PriceAndLabel item={item} key={item?.propertyId} isMapCard={true}/>
          {hasValidCountdown ? (
            <div className="d-flex flex-column align-items-end">
              {item?.listingEndDate && (
                <span className="auction-date-label-map">
                  Auction Ends: {formatAuctionDate(item.listingEndDate)}
                </span>
              )}
              <CountdownTimer until={item?.auctionTimeLeft / 1000} isMapCard={true} />
            </div>
          ) : (price != '' && priceLabel.length > 0) && (
            <div className="d-flex align-items-center justify-content-between pl5">
              <span className="card-item-head-map">
                {item?.tagName === 'UnderReview' && "Under Review"}
                {item?.listingType === "TRNL" && "Traditional Sale"}
                {item?.listingType === 'AUCN' && (item?.category !== 'FORECLOSURE' && item?.fcOnlineFlag !=='Y') && item?.tagName === 'UnderContract' && "Under Contract"}
                {item?.category === 'FORECLOSURE' && !item?.isFcProxyBidEnabled && item?.fcOnlineFlag !== 'Y' && item?.propertyStatus === 'AUCTION_EVENT_ENDED' && "Auction Ended"}
                {(item?.category === 'FORECLOSURE' && !item?.isFcProxyBidEnabled &&
                (item?.propertyStatus === 'SCHEDULED' || item?.propertyStatus === 'POSTPONED')) ?
                  item?.propertyStatus === 'SCHEDULED' ? 'Scheduled' : 'Postponed' : ""}
                {item?.category === 'FORECLOSURE' && !item?.isFcProxyBidEnabled && item?.fcOnlineFlag !== 'Y' &&
                item?.propertyStatus === 'CLEAR_TO_SALE' && "Cleared to sell"}
                {item?.category === 'FORECLOSURE' && !item?.isFcProxyBidEnabled && item?.fcOnlineFlag === 'Y' &&
                (item?.propertyStatus === 'AUCTION_EVENT_ENDED' || item?.propertyStatus ==='SPND' || item?.propertyStatus === 'UNDERCONTRACT') && "Auction Event Ended"}
              </span>
            </div>
          )}
        </div>
        {!(price != '' && priceLabel.length > 0) && !hasValidCountdown && (
          <div className="d-flex align-items-center justify-content-between pl5 pt20 mr10">
            <span className="card-item-head-map ">
              {item?.tagName === 'UnderReview' && "Under Review"}
              {item?.listingType === "TRNL" && "Traditional Sale"}
              {item?.listingType === 'AUCN' && (item?.category !== 'FORECLOSURE' && item?.fcOnlineFlag !=='Y') && item?.tagName === 'UnderContract' && "Auction Ended"}
              {item?.category === 'FORECLOSURE' && !item?.isFcProxyBidEnabled && item?.fcOnlineFlag !== 'Y' && item?.propertyStatus === 'AUCTION_EVENT_ENDED' && "Auction Ended"}
              {(item?.category === 'FORECLOSURE' && !item?.isFcProxyBidEnabled &&
              (item?.propertyStatus === 'SCHEDULED' || item?.propertyStatus === 'POSTPONED')) ?
                item?.propertyStatus === 'SCHEDULED' ? 'Scheduled' : 'Postponed' : ""}
              {item?.category === 'FORECLOSURE' && !item?.isFcProxyBidEnabled && item?.fcOnlineFlag !== 'Y' &&
              item?.propertyStatus === 'CLEAR_TO_SALE' && "Cleared to sell"}
              {item?.category === 'FORECLOSURE' && !item?.isFcProxyBidEnabled && item?.fcOnlineFlag === 'Y' &&
              (item?.propertyStatus === 'AUCTION_EVENT_ENDED' || item?.propertyStatus ==='SPND' || item?.propertyStatus === 'UNDERCONTRACT') && "Auction Event Ended"}
            </span>
          </div>
        )}
      </div>
    </div>
  );
}
export default CardItemMap;